import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getKhattabatStore from "../../../../stores/khattabat-stores";
import { TalkhattabatConversationType } from "../../../../Types";
import Body from "./body";
import Header from "./header";

const Conversation = withLiteObserverAndTheme<{
  conversationType: TalkhattabatConversationType;
  oneOTwoConversationId: string;
  alkhattabaUUID: string;
  userUUID: string;
  isValidSubscription: boolean;
  clientConversationID: string;
  unreadOneOOneCMessages: number;
  conversationIndex: number;
  isOneOOneCHiddenByKhattaba: boolean;
  clientID: number;
  oneOOneCId: string;
  applicationStatus: string
}>((props) => {
  const {
    theme,
    conversationType,
    oneOTwoConversationId,
    alkhattabaUUID,
    userUUID,
    isValidSubscription,
    clientConversationID,
    unreadOneOOneCMessages,
    conversationIndex,
    isOneOOneCHiddenByKhattaba,
    clientID,
    oneOOneCId,
    applicationStatus
  } = props;
  const { colors, unitY } = theme;

  const {
    conversationID,
    isConvExitedByMatch,
    isConvExitedByClient,
    exitedByMatchDate,
    exitedByClientDate,
    isPendingInteraction,
    messages,
    oneOOnePeerId,
    peerID,
    peerUUID,
    shouldNotShow,
    matchName
  } = getKhattabatStore().handleConversationPropsBetweenPages({
    conversationType,
    clientConversationID,
    oneOTwoConversationId,
    userUUID,
    conversationIndex,
    isOneOOneCHiddenByKhattaba
  });

  return shouldNotShow ? null : (
    <ET3Div
      width={1450}
      height={0}
      alignItems={"center"}
      fDirection={"column"}
      style={{ backgroundColor: colors.all.white, minHeight: 70 * unitY }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => { }}
    >
      <Et3Margin top={10} bottom={10} left={0} right={0} />
      <Header
        conversationType={conversationType}
        conversationID={conversationID}
        matchName={matchName}
        exitByMatch={isConvExitedByMatch}
        exitByClient={isConvExitedByClient}
        exitedByMatchDate={exitedByMatchDate}
        exitedByClientDate={exitedByClientDate}
        pendingInteraction={isPendingInteraction}
        peerID={peerID}
        clientConversationID={clientConversationID}
        oneOTwoConversationId={oneOTwoConversationId}
        clientID={clientID}
      />
      <Body
        conversationID={conversationID}
        oneOTwoConversationId={oneOTwoConversationId}
        conversationType={conversationType}
        messages={messages}
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        userID={oneOOnePeerId}
        peerID={peerID}
        peerUUID={peerUUID}
        isValidSubscription={isValidSubscription}
        unreadOneOOneCMessages={unreadOneOOneCMessages}
        exitedByMatch={isConvExitedByMatch}
        exitedByClient={isConvExitedByClient}
        oneOOneCId={oneOOneCId}
        applicationStatus={applicationStatus}
      />
    </ET3Div>
  );
});

export default Conversation;
